import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import HttpBackend from 'i18next-http-backend';
import { initReactI18next } from 'react-i18next';

import { LanguagesList, NamespacesList } from 'core/enums/common';

const getLanguage = () => i18n?.language || localStorage.getItem('i18nextLng') || 'en';
const languagesList = Object.keys(LanguagesList);
const namespacesList = Object.keys(NamespacesList);

try {
	i18n
		.use(LanguageDetector)
		.use(HttpBackend)
		.use(initReactI18next)
		.init({
			backend: {
				loadPath: languagesList.includes(getLanguage())
					? '/locales/{{lng}}/{{ns}}.json'
					: '/locales/en/{{ns}}.json',
			},
			preload: languagesList,
			ns: namespacesList,
			defaultNS: NamespacesList['common'],
			fallbackLng: LanguagesList['en'],
			interpolation: {
				escapeValue: false,
			},
		});
} catch (error) {
	/* empty */
}

export default i18n;
